import { Button, FormControl, FormLabel, Heading, Select } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import IconGenerateReport from 'assets/icons/icon-file-paper-line.svg?react';
import CardForm from 'components/ui/CardForm';
import FormControlGroup from 'components/ui/FormControlGroup';
import config from 'config';
import { useMessages } from 'hooks/useMessages';
import { useResourceList } from 'hooks/useResourceList';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useMemberReport } from '../hooks/useMemberReport';

interface FormValues {
  companyId: string;
}

const validationSchema = Yup.object().shape({
  companyId: Yup.string().required(),
});

export default function TabMembersReport() {
  const { onError } = useMessages();

  const { data: companies } = useResourceList({ 
    resourceName: 'companies'
  });

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as unknown as Resolver<FormValues>,
    defaultValues: {
      companyId: ''
    }
  });

  const { handleSubmit, register, formState: { errors, isValid } } = methods;

  const { onGenerateMemberReport, isPending } = useMemberReport({
    onSuccess: (filepath: string) => {
      window.location.assign(`${config.api}/${filepath}`);
    },
    onError: (error) => onError(error?.response?.data?.message)
  });

const onSubmit: SubmitHandler<FormValues> = (data) => onGenerateMemberReport(data);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardForm
          boxShadow="none"
          border="1px solid #E2E2E2"
          bgColor="rgba(240, 241, 242, 0.60)"
        >
          <Heading as="h3" size="h3">
            Gerar novo relatório
            <span>Preencha os filtros para gerar um novo relatório</span>
          </Heading>

          <FormControlGroup 
            mt="25px"
            mr="auto"
          >
            <FormControl isInvalid={!!errors.companyId} isRequired>
              <FormLabel>Empresa</FormLabel>
            { companies && (
              <Select 
                placeholder="Selecione uma empresa"
                {...register('companyId')}
              >
                { companies.map((company) => (
                  <option key={company.id} value={company.id}>{company.name}</option>
                ))}
              </Select>
            )}
            </FormControl>        
          </FormControlGroup>
          
          <Button 
            variant="primary"
            type="submit"
            ml="auto"
            rightIcon={<IconGenerateReport />}
            isDisabled={isPending || !isValid}
            isLoading={isPending}
          >
            Gerar relatório
          </Button>

        </CardForm>
      </form>
    </FormProvider>
  )
}
